<div class="dropdown-wrapper">
    <ham-button
        #documentsZipFilterButtonWrapper
        size="base"
        variant="primary"
        outline="true"
        icon="assets/hamIcons/folder-outline.svg"
        (buttonClick)="openFlyout(documentsZipFilterButtonWrapper)"
    >
        {{ 'aumico_ui_export_docs_as_zip' | i18next }}
    </ham-button>
</div>

<span class="menu-flyout" hamFlyout *ngIf="openedFlyout" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
    <div class="flyout-content">
        <div *ngFor="let option of documentsOptions">
            <label class="custom-checkbox status-option">
                <span class="label">{{ option.label }}</span>
                <input
                    type="checkbox"
                    [checked]="selectedWorkflowAreas.includes(option.value)"
                    (change)="onStatusSelection(option.value, $event.target.checked)"
                />
            </label>
        </div>
        <div class="divider"></div>
        <div class="status-option" (click)="exportZip()">
            <span
                hamIconShapes
                class="icon export-icon"
                icon="assets/hamIcons/folder-outline.svg"
                [variant]="'transparent'"
                [size]="'regular'"
            ></span>
            <span class="label export-button">{{ 'aumico_ui_export_docs_as_zip' | i18next }}</span>
        </div>
    </div>
</span>
